export enum BuildStagesEnum {
  ALL = 0,
  IDEA = 1,
  BUILD = 2,
  LAUNCH = 3,
}
